import React from 'react';

import makeDeprecatedJadeStyleTemplate from 'util/makeDeprecatedJadeStyleTemplate';

function SingleFragmentAssembly(): JSX.Element {
  return (
    <>
      <div className="assembly-navbar navbar">
        <button
          type="button"
          className="button button--small button--tertiaryGray pull-right u-small-spacing-left show-preview"
        >
          Hide Preview
        </button>
        <div className="add-fragment pull-right">
          <button type="button" className="button button--small button--tertiaryGray js-add">
            <span className="glyphicon glyphicon-plus" />
          </button>
        </div>
        <ul className="nav navbar-nav" />
      </div>
      <div className="construct">
        <div className="info active">
          <div className="assembly-step sequence-set">
            <div className="action-zone-mount" />
          </div>
        </div>
      </div>
    </>
  );
}

export default makeDeprecatedJadeStyleTemplate(SingleFragmentAssembly);
